import {makeStyles} from "@material-ui/core";
import styles from "../../../config/styles";

const style = () => makeStyles({
  settingsMobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    height: '85vh'
  },
  menuContainer: {
    width: '80%',
    flex: '0 75%'
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: styles.FONT_COLOR,
    width: '80%',
    flex: '0 15%'
  },
  header: {
    fontFamily: 'Optima',
    fontWeight: 700,
  },
  logOutContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  logOutRow: {
    fontFamily: 'Poppins-Medium',
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: styles.MAIN_COLOR,
    fontSize: 18
  }
})();


export default style;
